import { Star } from 'lucide-react'
import { getAllTime } from '../api.js'
import RankingPage from './RankingPage.jsx'

function AllTimePage() {
  return (
    <RankingPage
      eyebrow="ALL-TIME OPEN SOURCE RADAR"
      title="总榜"
      description="按项目当前 GitHub Star 总数排序，Fork 数和最近更新时间用于同分排序。"
      loadRanking={getAllTime}
      emptyTitle="总榜暂无数据"
      rankingLabel="按当前 Star 总数排序"
      rankingIcon={<Star size={17} />}
    />
  )
}

export default AllTimePage
